import { Phone } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { CLINIC } from "@/data/services";
import SocialLinks from "@/components/SocialLinks";
import Logo from "@/components/Logo";

const Footer = () => (
  <footer
    data-testid="main-footer"
    className="noise-overlay relative overflow-hidden border-t border-slate-200 bg-white pb-10 pt-20 text-slate-900"
  >
    <div className="mx-auto max-w-7xl px-6">
      <div className="flex flex-col justify-between gap-12 lg:flex-row">
        <div className="max-w-md">
          <div className="flex items-center gap-4">
            <Logo className="h-16 sm:h-20" />
          </div>
          <p className="mt-6 text-sm leading-relaxed text-slate-600">
            Ecografías de partes blandas, obstétricas, generales, morfológicas
            y genéticas. Exámenes de laboratorio clínico con resultados
            confiables.
          </p>
        </div>

        <div className="flex gap-16">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">
              Navegación
            </p>
            <ul className="mt-4 space-y-3">
              {[
                { id: "servicios", label: "Servicios" },
                { id: "nosotros", label: "Nosotros" },
                { id: "laboratorio", label: "Laboratorio" },
                { id: "contacto", label: "Contacto" },
              ].map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="text-sm text-slate-700 transition-colors hover:text-red-700"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">
              Contacto
            </p>
            <a
              data-testid="footer-phone"
              href={`tel:${CLINIC.phoneIntl}`}
              className="mt-4 flex items-center gap-2 text-sm text-slate-700 transition-colors hover:text-red-700"
            >
              <Phone size={14} className="text-red-600" />
              {CLINIC.phone}
            </a>
            <p className="mt-3 max-w-[220px] text-sm leading-relaxed text-slate-600">
              {CLINIC.address}
            </p>
          </div>
          <div data-testid="footer-socials">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">
              Síguenos
            </p>
            <div className="mt-4">
              <SocialLinks light />
            </div>
          </div>
        </div>
      </div>

      <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-slate-200 pt-8 sm:flex-row sm:items-center">
        <p className="text-xs text-slate-500">
          © 2026 ECOCORE DX Ecografía y Diagnóstico 🇨🇺. Todos los derechos
          reservados.
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">
          Diagnóstico con precisión y calidez humana
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
